import { render, staticRenderFns } from "./productCategoryDialog.vue?vue&type=template&id=35531908&scoped=true"
import script from "./productCategoryDialog.vue?vue&type=script&lang=js"
export * from "./productCategoryDialog.vue?vue&type=script&lang=js"
import style0 from "./productCategoryDialog.vue?vue&type=style&index=0&id=35531908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35531908",
  null
  
)

export default component.exports